const classConfig = {
    sidebar: '.navigation-categories',
    label: '.navigation-categories__label',
    link: '.navigation__link',
    content: '.navigation-subcategories',
    contentShow: 'show',
};

function init() {
    let sidebar = document.querySelector(classConfig.sidebar);

    if (sidebar) {
        let navigationLabels = sidebar.querySelectorAll(classConfig.label);

        if (navigationLabels) {
            navigationLabels.forEach(label => {
                label.addEventListener('click', () => {
                    handleLabelToggle(label);
                });
            });
        }

        handleLocationToggle();
    }
}

function handleLabelToggle(label) {
    let content = label.parentNode.querySelector(classConfig.content),
        contentHeight;

    label.parentNode.classList.toggle('show');

    // contentHeight = label.parentNode.classList.contains('show') ? content.scrollHeight : 0;
    // content.setAttribute('style', 'min-height: ' + contentHeight + 'px');
    // if(label.parentNode.classList.contains('show')) {
    // if($(label).parent().parent().hasClass('.navigation-subcategories')) {
    //     let newContentHeight = $(label).parent().parent().parent().scrollHeight;
    //     $(label).parent().parent().setAttribute('style', 'max-height: ' + newContentHeight + 'px');
    // }
    // }
}

function handleLocationToggle() {
    if (window.innerWidth >= 992) {
        let locationSlug = window.location.pathname.split('/');

        locationSlug.forEach(slug => {
            let locationLabel = document.querySelector('[data-slug="' + slug + '"]');

            locationLabel ? locationLabel.click() : false;
        });
    }
}

export default {init};



// WEBPACK FOOTER //
// ./src/scripts/sidebar-list.js